import Vue from 'vue';
import App from './App.vue';
import store from '../../store'
import "@assets/css/reset.scss";
import "@assets/css/common.scss";
import "../../plugins/vue2-toast";
import VueLazyload from 'vue-lazyload'

import "@assets/js/rem.js";


Vue.use(VueLazyload)

Vue.config.productionTip = false;

window.$app = new Vue({
  store,
  render: (h) => h(App),
}).$mount('#app');
